import { Component, OnDestroy, OnInit } from '@angular/core';
import { ErrorParser } from '@app/classes';
import { Account } from '@app/models/payroll/company/chart-of-accounts.model';
import { XeroAccountMapping } from '@app/models/payroll/company/xero-account-mapping.model';
import { JournalEntryReportItemTemplateCategories } from '@app/modules/settings/enums/journal-entry-report-line-item-categories.enum';
import { XeroManageService } from '@app/modules/settings/services';
import { NotifyService, PayrollSettingsService } from '@app/services';
import groupBy from 'lodash-es/groupBy';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-xero-manage-view',
    templateUrl: './xero-manage.template.html',
})
export class XeroManageView implements OnInit, OnDestroy {
    accountMappingGroups: Array<[JournalEntryReportItemTemplateCategories, XeroAccountMapping[]]> = [];
    chartOfAccounts: Account[] = [];

    isLoading = true;
    importSettingLoading = true;
    importAsBill = true;

    private subscriptions: Subscription[] = [];

    constructor(
        private notify: NotifyService,
        private manageService: XeroManageService,
        private settingsService: PayrollSettingsService
    ) {}

    async ngOnInit(): Promise<void> {
        this.settingsService.load();
        this.subscriptions.push(
            this.settingsService.loading$.subscribe((loading) => {
                this.importSettingLoading = loading;
            }),
            this.settingsService.settings$.subscribe(({ reportJournalEntryReportsToXeroAs }) => {
                if (reportJournalEntryReportsToXeroAs) {
                    this.importAsBill = reportJournalEntryReportsToXeroAs === 'Invoice';
                }
            })
        );

        const [accountMappings, chartOfAccounts] = await Promise.all([
            this.manageService.getAccountMappings(),
            this.manageService.getChartOfAccounts(),
        ]);

        this.accountMappingGroups = Object.entries(
            groupBy(accountMappings, (accountMapping) => accountMapping.journalEntryReportItemTemplate.category)
        ) as Array<[JournalEntryReportItemTemplateCategories, XeroAccountMapping[]]>;

        this.chartOfAccounts = chartOfAccounts;

        this.isLoading = false;
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    updateImportSetting(): void {
        this.settingsService.settings.reportJournalEntryReportsToXeroAs = this.importAsBill
            ? 'Invoice'
            : 'JournalEntry';
        this.settingsService.save();
    }

    updateMapping(mapping: XeroAccountMapping, code: string): void {
        this.manageService.updateAccountMapping(mapping, code).catch((e) => {
            this.notify.error(ErrorParser.parse(e));
        });
    }
}
